import { consentKey } from "./consent/consentHandler";
export function renderHotJarScript() {
    let consentStateString = localStorage.getItem(consentKey);
    let consentState = consentStateString ? JSON.parse(consentStateString) : null;
    let renderHotJar = consentState && (consentState === null || consentState === void 0 ? void 0 : consentState.details.pixel);
    if (renderHotJar) {
        let script = "(function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:2069703,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";
        let hotJarScript = document.createElement('script');
        hotJarScript.innerHTML = script;
        document.head.appendChild(hotJarScript);
    }
}
